import React from "react";
import MemberNavbarComponent from "./MemberNavbarComponent";
import MemberHeaderComponent from "./MemberHeaderComponent";
import postmanCreatLinkImg from '../../assets/images/shortlinkmember.jpg';
import loginImg from '../../assets/images/loginandgettokenmember.jpg';
import resultQrCodeImg from '../../assets/images/qrcodemember.jpg';
import resultENTHImg from '../../assets/images/returntextmember.jpg';

const DocComponent: React.FC = () => {
    return (
        <div className="bg-light">
            <MemberHeaderComponent />
            <div className="container-fluid">
                <MemberNavbarComponent />
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2">Document</h1>
                        <div className="btn-toolbar mb-2 mb-md-0"></div>
                    </div>
                    <div className="row" id="gettokenpage">
                        <div className="col-12 mb-5">
                            <h2>Get Token</h2>
                        </div>
                        <div className="col-12">
                            <h3>Postman/Thunder Client</h3>
                        </div>
                        <div className="col-12">
                            <img src={loginImg} alt="Login Document" className="img-fluid" />
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                    <div className="row" id="shortlinkpage">
                        <div className="col-12 mb-5">
                            <h2>Short Link</h2>
                        </div>
                        <div className="col-12">
                            <h3>Postman/Thunder Client</h3>
                        </div>
                        <div className="col-12">
                            <img src={postmanCreatLinkImg} alt="Postman Create Link" className="img-fluid" />
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                    <div className="row" id="qrcodepage">
                        <div className="col-12 mb-5">
                            <h2>QR Code</h2>
                        </div>
                        <div className="col-12">
                            <h3>Postman / Thunder Client</h3>
                        </div>
                        <div className="col-12">
                            <img src={resultQrCodeImg} alt="Result QR Code" className="img-fluid" />
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                    <div className="row" id="enthpage">
                        <div className="col-12 mb-5">
                            <h2>EN? {'->'} TH</h2>
                        </div>
                        <div className="col-12">
                            <h3>Postman / Thunder Client</h3>
                        </div>
                        <div className="col-12">
                            <img src={resultENTHImg} alt="Result EN to TH" className="img-fluid" />
                        </div>
                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default DocComponent;
